import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { contactFormSendReducer, emailListSendReducer } from "./reducers/contactReducers";



const initialState = {
  
};

const reducer = combineReducers({
  contactFormSend: contactFormSendReducer,
  emailListSend: emailListSendReducer,
});
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducer,
  initialState,
  composeEnhancer(applyMiddleware(thunk))
);

export default store;
